module.exports = __webpack_public_path__ + "img/CZE.01c6160b.svg";